import store from '@store'
import menuTemplate from '@/services/menu'
export const checkPassport = (to, from, next) => {
  let menuProvideUser = store.getters.menuList
  if(menuProvideUser.length === 0) {
    next()
    return
  }
  let pass = false
  let targetName = to.name
  menuProvideUser.forEach(o => {
    if(o.target.name == targetName) {
      pass = true
    }
    o.subGroup.forEach(s => {
      if(s.target && s.target.name == targetName) {
        pass = true
      }
    })
  })
  if(pass) {
    next()
  } else {
    console.error('menuProvideUser', menuProvideUser, )
    // alert('fail')
     next({name: '401'})
  }
}
